<template>
  <div class="container">
    <img src="@/assets/images/recruit/recruit_detail_pc.png" class="bgImg pcShow" />
    <img src="@/assets/images/recruit/recruit_detail.png" class="bgImg mobileShow" />
    <online-service/>
  </div>
</template>
<script>
import OnlineService from "./OnlineService.vue";
export default {
  name: "recruitDetail",
  components: {
    OnlineService,
  },
  data() {
    return {
      textObj: {
        en: {
          onlineService: "Live Chat",
        },
        vi: {
          onlineService: "Liên hệ",
        },
      },
      lang: "en",
      active: 0,
    };
  },
  computed: {
    isMobile() {
      return window.innerWidth <= 768;
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.lang = localStorage.getItem("lang") || "en";
    },
  },
};
</script>

<style scoped>
.container {
  margin: 0;
}
.mobileShow {
  display: none !important;
  @media screen and (max-width: 768px) {
    display: block !important;
  }
}
.pcShow {
  display: block !important;
  @media screen and (max-width: 768px) {
    display: none !important;
  }
}
.bgImg {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/RecruitDetail.vue